// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #e3e4e8;
  --fg: #17181c;
  --dur: 8s;
}

body {
  color: white;
  font: bold 1em/1.5 'Comfortaa', sans-serif;
}
.hexagon {
  margin-bottom: 1.5em;
  overflow: hidden;
  position: relative;
  width: 15em;
  height: 15em;
  bottom: 136px;
}
.hexagon__group,
.hexagon__sector,
.hexagon__sector:before,
.hexagon__sector:after {
  position: absolute;
}
.hexagon__group {
  width: 100%;
  height: 100%;
}
.hexagon__group:nth-child(2) .hexagon__sector,
.hexagon__group:nth-child(2) .hexagon__sector:before,
.hexagon__group:nth-child(2) .hexagon__sector:after {
  animation-delay: calc(var(--dur) * -1 / 6);
}
.hexagon__group:nth-child(3) .hexagon__sector,
.hexagon__group:nth-child(3) .hexagon__sector:before,
.hexagon__group:nth-child(3) .hexagon__sector:after {
  animation-delay: calc(var(--dur) * -2 / 6);
}
.hexagon__group:nth-child(4) .hexagon__sector,
.hexagon__group:nth-child(4) .hexagon__sector:before,
.hexagon__group:nth-child(4) .hexagon__sector:after {
  animation-delay: calc(var(--dur) * -3 / 6);
}
.hexagon__group:nth-child(5) .hexagon__sector,
.hexagon__group:nth-child(5) .hexagon__sector:before,
.hexagon__group:nth-child(5) .hexagon__sector:after {
  animation-delay: calc(var(--dur) * -4 / 6);
}
.hexagon__group:nth-child(6) .hexagon__sector,
.hexagon__group:nth-child(6) .hexagon__sector:before,
.hexagon__group:nth-child(6) .hexagon__sector:after {
  animation-delay: calc(var(--dur) * -5 / 6);
}
.hexagon__group:nth-child(odd) {
  transform: rotate(30deg);
}
.hexagon__sector,
.hexagon__sector:before,
.hexagon__sector:after {
  animation-duration: var(--dur);
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  /*animation-play-state: paused;*/
  width: 0.2em;
  height: 0.2em;
}
.hexagon__sector {
  animation-name: moveOut1;
  top: calc(50% - 0.1em);
  left: calc(50% - 0.1em);
}
.hexagon__sector:nth-child(2) {
  animation-name: moveOut2;
}
.hexagon__sector:nth-child(3) {
  animation-name: moveOut3;
}
.hexagon__sector:nth-child(4) {
  animation-name: moveOut4;
}
.hexagon__sector:nth-child(5) {
  animation-name: moveOut5;
}
.hexagon__sector:nth-child(6) {
  animation-name: moveOut6;
}
.hexagon__sector:before,
.hexagon__sector:after {
  animation-name: ripple;
  background-color: white;
  border-radius: 0.1em;
  content: '';
  display: block;
  top: 0;
  left: 0;
  transform-origin: 0.1em 0.1em;
}
.hexagon__sector:before {
  transform: rotate(-30deg);
}
.hexagon__sector:after {
  transform: rotate(-150deg);
}
/* Dark theme */
@media (prefers-color-scheme: dark) {
  :root {
    --bg: #17181c;
    --fg: #e3e4e8;
  }
}
/* Animations */
@keyframes moveOut1 {
  from {
    transform: translateY(0) scale(0);
  }
  3% {
    transform: translateY(0.2em) scale(1);
  }
  97% {
    transform: translateY(7.3em) scale(1);
  }
  to {
    transform: translateY(7.5em) scale(0);
  }
}
@keyframes moveOut2 {
  from {
    transform: rotate(60deg) translateY(0) scale(0);
  }
  3% {
    transform: rotate(60deg) translateY(0.2em) scale(1);
  }
  97% {
    transform: rotate(60deg) translateY(7.3em) scale(1);
  }
  to {
    transform: rotate(60deg) translateY(7.5em) scale(0);
  }
}
@keyframes moveOut3 {
  from {
    transform: rotate(120deg) translateY(0) scale(0);
  }
  3% {
    transform: rotate(120deg) translateY(0.2em) scale(1);
  }
  97% {
    transform: rotate(120deg) translateY(7.3em) scale(1);
  }
  to {
    transform: rotate(120deg) translateY(7.5em) scale(0);
  }
}
@keyframes moveOut4 {
  from {
    transform: rotate(180deg) translateY(0) scale(0);
  }
  3% {
    transform: rotate(180deg) translateY(0.2em) scale(1);
  }
  97% {
    transform: rotate(180deg) translateY(7.3em) scale(1);
  }
  to {
    transform: rotate(180deg) translateY(7.5em) scale(0);
  }
}
@keyframes moveOut5 {
  from {
    transform: rotate(240deg) translateY(0) scale(0);
  }
  3% {
    transform: rotate(240deg) translateY(0.2em) scale(1);
  }
  97% {
    transform: rotate(240deg) translateY(7.3em) scale(1);
  }
  to {
    transform: rotate(240deg) translateY(7.5em) scale(0);
  }
}
@keyframes moveOut6 {
  from {
    transform: rotate(300deg) translateY(0) scale(0);
  }
  3% {
    transform: rotate(300deg) translateY(0.2em) scale(1);
  }
  97% {
    transform: rotate(300deg) translateY(7.3em) scale(1);
  }
  to {
    transform: rotate(300deg) translateY(7.5em) scale(0);
  }
}
@keyframes ripple {
  from,
  to {
    width: 0.2em;
  }
  33% {
    width: 2.4em;
  }
}

.center {
  text-align: center;
  position: relative;
  bottom: 160px;
}
`, "",{"version":3,"sources":["webpack://./client/features/loader/loader.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;AACA;;;;EAIE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;;;EAGE,0CAA0C;AAC5C;AACA;EACE,wBAAwB;AAC1B;AACA;;;EAGE,8BAA8B;EAC9B,mCAAmC;EACnC,iCAAiC;EACjC,gCAAgC;EAChC,YAAY;EACZ,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA,eAAe;AACf;EACE;IACE,aAAa;IACb,aAAa;EACf;AACF;AACA,eAAe;AACf;EACE;IACE,iCAAiC;EACnC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,+CAA+C;EACjD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;AACF;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,oDAAoD;EACtD;AACF;AACA;EACE;;IAEE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[":root {\r\n  --bg: #e3e4e8;\r\n  --fg: #17181c;\r\n  --dur: 8s;\r\n}\r\n\r\nbody {\r\n  color: white;\r\n  font: bold 1em/1.5 'Comfortaa', sans-serif;\r\n}\r\n.hexagon {\r\n  margin-bottom: 1.5em;\r\n  overflow: hidden;\r\n  position: relative;\r\n  width: 15em;\r\n  height: 15em;\r\n  bottom: 136px;\r\n}\r\n.hexagon__group,\r\n.hexagon__sector,\r\n.hexagon__sector:before,\r\n.hexagon__sector:after {\r\n  position: absolute;\r\n}\r\n.hexagon__group {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n.hexagon__group:nth-child(2) .hexagon__sector,\r\n.hexagon__group:nth-child(2) .hexagon__sector:before,\r\n.hexagon__group:nth-child(2) .hexagon__sector:after {\r\n  animation-delay: calc(var(--dur) * -1 / 6);\r\n}\r\n.hexagon__group:nth-child(3) .hexagon__sector,\r\n.hexagon__group:nth-child(3) .hexagon__sector:before,\r\n.hexagon__group:nth-child(3) .hexagon__sector:after {\r\n  animation-delay: calc(var(--dur) * -2 / 6);\r\n}\r\n.hexagon__group:nth-child(4) .hexagon__sector,\r\n.hexagon__group:nth-child(4) .hexagon__sector:before,\r\n.hexagon__group:nth-child(4) .hexagon__sector:after {\r\n  animation-delay: calc(var(--dur) * -3 / 6);\r\n}\r\n.hexagon__group:nth-child(5) .hexagon__sector,\r\n.hexagon__group:nth-child(5) .hexagon__sector:before,\r\n.hexagon__group:nth-child(5) .hexagon__sector:after {\r\n  animation-delay: calc(var(--dur) * -4 / 6);\r\n}\r\n.hexagon__group:nth-child(6) .hexagon__sector,\r\n.hexagon__group:nth-child(6) .hexagon__sector:before,\r\n.hexagon__group:nth-child(6) .hexagon__sector:after {\r\n  animation-delay: calc(var(--dur) * -5 / 6);\r\n}\r\n.hexagon__group:nth-child(odd) {\r\n  transform: rotate(30deg);\r\n}\r\n.hexagon__sector,\r\n.hexagon__sector:before,\r\n.hexagon__sector:after {\r\n  animation-duration: var(--dur);\r\n  animation-iteration-count: infinite;\r\n  animation-timing-function: linear;\r\n  /*animation-play-state: paused;*/\r\n  width: 0.2em;\r\n  height: 0.2em;\r\n}\r\n.hexagon__sector {\r\n  animation-name: moveOut1;\r\n  top: calc(50% - 0.1em);\r\n  left: calc(50% - 0.1em);\r\n}\r\n.hexagon__sector:nth-child(2) {\r\n  animation-name: moveOut2;\r\n}\r\n.hexagon__sector:nth-child(3) {\r\n  animation-name: moveOut3;\r\n}\r\n.hexagon__sector:nth-child(4) {\r\n  animation-name: moveOut4;\r\n}\r\n.hexagon__sector:nth-child(5) {\r\n  animation-name: moveOut5;\r\n}\r\n.hexagon__sector:nth-child(6) {\r\n  animation-name: moveOut6;\r\n}\r\n.hexagon__sector:before,\r\n.hexagon__sector:after {\r\n  animation-name: ripple;\r\n  background-color: white;\r\n  border-radius: 0.1em;\r\n  content: '';\r\n  display: block;\r\n  top: 0;\r\n  left: 0;\r\n  transform-origin: 0.1em 0.1em;\r\n}\r\n.hexagon__sector:before {\r\n  transform: rotate(-30deg);\r\n}\r\n.hexagon__sector:after {\r\n  transform: rotate(-150deg);\r\n}\r\n/* Dark theme */\r\n@media (prefers-color-scheme: dark) {\r\n  :root {\r\n    --bg: #17181c;\r\n    --fg: #e3e4e8;\r\n  }\r\n}\r\n/* Animations */\r\n@keyframes moveOut1 {\r\n  from {\r\n    transform: translateY(0) scale(0);\r\n  }\r\n  3% {\r\n    transform: translateY(0.2em) scale(1);\r\n  }\r\n  97% {\r\n    transform: translateY(7.3em) scale(1);\r\n  }\r\n  to {\r\n    transform: translateY(7.5em) scale(0);\r\n  }\r\n}\r\n@keyframes moveOut2 {\r\n  from {\r\n    transform: rotate(60deg) translateY(0) scale(0);\r\n  }\r\n  3% {\r\n    transform: rotate(60deg) translateY(0.2em) scale(1);\r\n  }\r\n  97% {\r\n    transform: rotate(60deg) translateY(7.3em) scale(1);\r\n  }\r\n  to {\r\n    transform: rotate(60deg) translateY(7.5em) scale(0);\r\n  }\r\n}\r\n@keyframes moveOut3 {\r\n  from {\r\n    transform: rotate(120deg) translateY(0) scale(0);\r\n  }\r\n  3% {\r\n    transform: rotate(120deg) translateY(0.2em) scale(1);\r\n  }\r\n  97% {\r\n    transform: rotate(120deg) translateY(7.3em) scale(1);\r\n  }\r\n  to {\r\n    transform: rotate(120deg) translateY(7.5em) scale(0);\r\n  }\r\n}\r\n@keyframes moveOut4 {\r\n  from {\r\n    transform: rotate(180deg) translateY(0) scale(0);\r\n  }\r\n  3% {\r\n    transform: rotate(180deg) translateY(0.2em) scale(1);\r\n  }\r\n  97% {\r\n    transform: rotate(180deg) translateY(7.3em) scale(1);\r\n  }\r\n  to {\r\n    transform: rotate(180deg) translateY(7.5em) scale(0);\r\n  }\r\n}\r\n@keyframes moveOut5 {\r\n  from {\r\n    transform: rotate(240deg) translateY(0) scale(0);\r\n  }\r\n  3% {\r\n    transform: rotate(240deg) translateY(0.2em) scale(1);\r\n  }\r\n  97% {\r\n    transform: rotate(240deg) translateY(7.3em) scale(1);\r\n  }\r\n  to {\r\n    transform: rotate(240deg) translateY(7.5em) scale(0);\r\n  }\r\n}\r\n@keyframes moveOut6 {\r\n  from {\r\n    transform: rotate(300deg) translateY(0) scale(0);\r\n  }\r\n  3% {\r\n    transform: rotate(300deg) translateY(0.2em) scale(1);\r\n  }\r\n  97% {\r\n    transform: rotate(300deg) translateY(7.3em) scale(1);\r\n  }\r\n  to {\r\n    transform: rotate(300deg) translateY(7.5em) scale(0);\r\n  }\r\n}\r\n@keyframes ripple {\r\n  from,\r\n  to {\r\n    width: 0.2em;\r\n  }\r\n  33% {\r\n    width: 2.4em;\r\n  }\r\n}\r\n\r\n.center {\r\n  text-align: center;\r\n  position: relative;\r\n  bottom: 160px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
